<div class="gap-[40px] flex flex-col min-h-[calc(100vh-74px)] shrink-0 justify-start items-center pt-[40px] pb-[48px] bg-[#f2f5f7ff] w-[100%] relative px-[24px] md:px-[32px]">
  <button
    type="button"
    class="delivery-home-back absolute top-[24px] left-[24px] md:left-[32px] z-10 inline-flex items-center gap-[8px] h-[40px] px-[12px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
    (click)="goBack()"
    aria-label="Back">
    <svg class="w-[16px] h-[16px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span>Back</span>
  </button>
  <span class="w-[100%] shrink-0 justify-start items-start self-stretch text-[#111215ff] text-center font-normal font-['Archivo'] text-[24px] leading-[32px] pt-[16px]">
    Welcome, {{ staffName }}
  </span>
  <div class="gap-[16px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
    <span class="shrink-0 justify-start items-start text-[#111215ff] text-center font-bold font-['Archivo'] text-[24px] leading-[29px]">
      Pick What Your service delivery
    </span>
    <div class="gap-[28px] flex flex-row flex-wrap w-[100%] shrink-0 justify-center items-start self-stretch px-[24px] md:px-[48px]">
      <button
        *ngFor="let card of serviceCards"
        type="button"
        class="delivery-service-card flex flex-col w-[240px] shrink-0 rounded-[8px] justify-start items-start border-[2px] border-transparent bg-transparent p-0 cursor-pointer overflow-hidden transition-transform duration-200 hover:-translate-y-[4px] focus:outline-none focus-visible:border-[#f26f24]"
        [attr.aria-label]="'Open ' + card.label + ' service delivery'"
        (click)="onSelectService(card)"
      >
        <img
          *ngIf="card.image"
          [src]="card.image"
          [alt]="card.alt"
          loading="lazy"
          decoding="async"
          class="w-[240px] h-[240px] shrink-0 justify-start items-start object-cover"
        />
        <div
          *ngIf="!card.image"
          class="w-[240px] h-[240px] shrink-0 bg-[#eaecf0]"
          aria-hidden="true"
        ></div>
        <div class="gap-[24px] flex flex-row w-[100%] shrink-0 justify-start items-center self-stretch">
          <div class="gap-[8px] flex flex-col w-[100%] h-[74px] rounded-br-[4px] rounded-bl-[4px] shrink-0 justify-center items-center grow basis-0 pl-[16px] pr-[16px] pt-[20px] pb-[20px] bg-[#ffffffff] shadow-[0px_1px_3px_0px_#10182819] border-[1px] border-[#eaecf0]">
            <span class="w-[100%] shrink-0 justify-start items-start self-stretch text-[#111215ff] text-center font-bold font-['Archivo'] text-[18px] leading-[32px]">
              {{ card.label }}
            </span>
          </div>
        </div>
      </button>
      <div
        *ngIf="isLoadingActivities"
        class="flex flex-col w-[240px] h-[314px] shrink-0 rounded-[8px] justify-center items-center bg-[#ffffffff] border-[1px] border-[#eaecf0] text-[#667085] font-['Archivo'] text-[14px]"
        aria-live="polite"
      >
        Loading activities…
      </div>
    </div>
  </div>
</div>
